import $http from './http'
import config from './config'
export default {
    name: 'huilianyi',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    searchapprovals(){
        return $http.post(this.getUrl(`/huilianyi/searchApproval?status=`),{},{failTips:false});
    },
    booking(id){
        return $http.get(this.getUrl('/huilianyi/booking?id='+id))
    },
    OrderNotify(UniqueID,orderservice){
        return $http.get(this.getUrl(`/service/OrderNotify?id=${UniqueID}&orderservice=${orderservice}`),{failTips:false})
    },
    PushTradeList(OrderID,serviceType){
        return $http.get(this.getUrl(`/service/PushTradeList?OrderID=${OrderID}&serviceType=${serviceType}`),{failTips:false})
    },
}


// WEBPACK FOOTER //
// ./src/apis/huilianyiapi.js